export const DOMAINS_LIST_ACTION = "DOMAINS_LIST_ACTION"
export const ADD_DOMAIN_ACTION = "ADD_DOMAINS_ACTION";
export const UPDATE_DOOMAIN_ACTION = 'UPDATE_DOMAIN_ACTION';


export const domainsList=(domainsList)=>({
    type: DOMAINS_LIST_ACTION ,
    payload: domainsList

})

export const addDomain = (domain) => ({
    type: ADD_DOMAIN_ACTION,
    payload: domain,
});

export const updateDomain = (domain) => ({
    type: UPDATE_DOOMAIN_ACTION,
    payload: domain,
  });

  